'use client';

import { Canvas, CanvasProps } from '@react-three/fiber';
// import { Preload } from '@react-three/drei';
import { r3f } from '../_helpers/global';
import { PerspectiveCameraProps, PerspectivePixelCamera } from '../_helpers/PerspectivePixelCamera';

export type GlobalCanvasProps = Omit<CanvasProps, 'children'> & { cameraProps?: PerspectiveCameraProps };

export default function GlobalCanvas(props: GlobalCanvasProps) {
	const { gl, cameraProps, ...canvasProps } = props;

	return (
		<Canvas
			gl={{
				// https://blog.tojicode.com/2013/12/failifmajorperformancecaveat-with-great.html
				failIfMajorPerformanceCaveat: true, // skip webgl if slow device
				...gl,
			}}
			{...canvasProps}
		>
			<PerspectivePixelCamera {...cameraProps} />
			<r3f.Out />
			{/* <Preload all /> */}
		</Canvas>
	);
}
